"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filebar_menu_html_1 = __importDefault(require("./filebar-menu.html"));
(function (module) {
    EditMenuController.$inject = [
        // '$filter',
        // 'undoRedoStack'
        '$filter',
        'pr.hotkeyUtil',
        'prFlowingPages'
    ];
    //function EditMenuController ($filter, undoRedo) {
    function EditMenuController($filter, hotkey, flowingPages) {
        var $ctrl = this, translate = $filter('translate');
        angular.extend($ctrl, {
            id: 'EDIT',
            label: translate('EDIT'),
            getMenuItems: function () {
                var hasSelectedWidgets = $ctrl.bodyCtrl.hasSelectedWidgets();
                return [
                    /*
                    {
                        icon: 'icon-undo',
                        replaceCheck: true,
                        label: hotkey.buildHotkeyLabel('UNDO', ['icon-commandkey', 'Z']),
                        action: function() {
                            undoRedo.undo();
                        }
                    },
                    {
                        icon: 'icon-redo',
                        replaceCheck: true,
                        label: hotkey.buildHotkeyLabel('REDO', ['icon-shiftkey', 'icon-commandkey', 'Z']),
                        action: function() {
                            undoRedo.redo();
                        }
                    },
                    {divider:true},
                    {
                        label: hotkey.buildHotkeyLabel('CUT', ['icon-commandkey', 'X']),
                        action: function() {
                            // TODO: Cut
                        },
                        disabled: true
                    },
                    */
                    {
                        disabled: !hasSelectedWidgets || flowingPages.hasReachedWidgetLimit(),
                        label: hotkey.buildHotkeyLabel('COPY', ['icon-commandkey', 'C']),
                        action: function () {
                            $ctrl.bodyCtrl.copyWidgets();
                        },
                        icon: 'icon-twofiles2',
                        replaceCheck: true
                    },
                    {
                        disabled: !hasSelectedWidgets || flowingPages.hasReachedWidgetLimit(),
                        label: hotkey.buildHotkeyLabel('PASTE', ['icon-commandkey', 'V']),
                        action: function () {
                            $ctrl.bodyCtrl.pasteWidgets();
                        },
                        icon: 'icon-survey-wire',
                        replaceCheck: true
                    },
                    {
                        disabled: !hasSelectedWidgets,
                        label: hotkey.buildHotkeyLabel('REMOVE', ['icon-commandkey', 'DELETE']),
                        action: function () {
                            $ctrl.bodyCtrl.deleteWidgets();
                        },
                        icon: 'icon-trash-bin',
                        replaceCheck: true
                    }
                ];
            }
        });
    }
    module.component('prEditMenu', {
        controller: EditMenuController,
        templateUrl: filebar_menu_html_1.default,
        require: {
            bodyCtrl: '^^prBody',
            fbCtrl: '^^prFilebar'
        }
    });
}(angular.module('qualtrics.pr')));
